import { filter } from 'rxjs/operators';
import { LoginChallengeResult } from './../models/authentication/login.challenge.result';
import { Observable, Subscription } from 'rxjs';
import { DialogPanelComponentContent } from './../models/dialogs/DialogPanelComponentContent';
import { MatDialogRef } from '@angular/material/dialog';
import { HubLoginComponent } from './../components/hub-login/hub-login.component';
import { DialogsService } from './dialogs.service';
import { Injectable } from '@angular/core';
import { Router, NavigationEnd, ActivatedRouteSnapshot } from '@angular/router';
import { LoginChallengeResultType } from '../models/authentication/login.challenge.result.types';
import { SettingsService } from './settings/settings.service';

@Injectable()
export class LoginWraperService {
  private panelOpen: boolean = false;
  private dialogReference: MatDialogRef<DialogPanelComponentContent>;
  private enableBoomerangBehavior: boolean;
  private loginInProgress: boolean;
  private loginSubscription: Subscription;

  constructor(
    private dialogsService: DialogsService,
    private router: Router,
    private settingsService: SettingsService
  ) {
    // override the route reuse strategy
    const defaultStrategy = this.router.routeReuseStrategy.shouldReuseRoute;
    // reload current route if was a login
    this.router.routeReuseStrategy.shouldReuseRoute = (
      future: ActivatedRouteSnapshot,
      current: ActivatedRouteSnapshot
    ) => {
      const loginWasInProgress = this.loginInProgress;
      if (loginWasInProgress) {
        this.loginInProgress = false;
      }

      return loginWasInProgress && this.enableBoomerangBehavior
        ? false
        : defaultStrategy(future, current);
    };

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(evt => {
        this.router.navigated = false;
      });
  }

  /**
   * Requisita login ao usuário a partir da gaveta lateral
   * @param enableBoomerangBehavior habilitar o efeito boomerang (refresh da rota atual sem recarregar a aplicação)
   */
  public requestUserLogin(enableBoomerangBehavior = true): Observable<any> {
    this.enableBoomerangBehavior = enableBoomerangBehavior;
    this.loginInProgress = true;
    this.dialogReference = this.dialogsService.showComponentAsAsidePanel(
      HubLoginComponent,
      true
    );

    if (this.loginSubscription) {
      this.loginSubscription.unsubscribe();
    }
    this.loginSubscription = this.dialogReference
      .afterClosed()
      .subscribe((result: LoginChallengeResult) => {
        if (
          enableBoomerangBehavior &&
          result.result === LoginChallengeResultType.Success
        ) {
          const url = this.router.url;
          this.router.navigated = false;
          this.router.navigateByUrl(this.router.createUrlTree([url]));
        }
      });

    return this.dialogReference.afterClosed();
  }

  public dispose() {
    this.dialogReference.close();
  }

  public afterLoginEnd() {
    if (null == this.dialogReference) {
      return null;
    }

    return this.dialogReference.afterClosed();
  }

  /**
   * ATENÇÃO: Metodo temporário, apenas para fins de separação do Site e Home Logada.
   * Navega para a página de login
   */
  public navigateToLogin(options: { afterLoginRedirectTo?: string } = {}) {
    const { afterLoginRedirectTo } = options;

    const redirectTo = encodeURIComponent(afterLoginRedirectTo);
    const url =
      afterLoginRedirectTo && afterLoginRedirectTo !== '/'
        ? `/entrar?redirectTo=${redirectTo}`
        : '/entrar';

    if (this.settingsService.isOnLoggedDomain()) {
      this.router.navigateByUrl(url);
    } else {
      window.location.href = `${this.settingsService.getConfigurationKeyValue(
        'hubUrl'
      )}${url}`;
    }
  }
}
